import { RouteRecordRaw } from 'vue-router';

import { FilterType } from '../models/filter';
import { PortalDefinition } from '../models/definition';
import SearchResults from '../presentation/components/search-results/SearchResults.vue';
import { Routes } from './Routes';
import RoutingDefinitions from './RoutingDefinitions';

export class ShortCoursesRoutes extends Routes {
	public getRoutes(portalDefinition: PortalDefinition): RouteRecordRaw[] {
		const routes = super.getRoutes(portalDefinition);

		const educationalFormRegex = portalDefinition.getFilterDefinition(FilterType.EDUCATIONAL_FORM).getPathRegex();
		const disciplinesRegex = portalDefinition.getFilterDefinition(FilterType.DISCIPLINES).getPathRegex();
		const countryRegex = portalDefinition.getFilterDefinition(FilterType.COUNTRY).getPathRegex();

		const DISCIPLINE_EDUCATIONAL_FORM_ROUTE = {
			path: `:discipline(${disciplinesRegex})/:educational_form(${educationalFormRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_EDUCATIONAL_FORM_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
		};

		const DISCIPLINE_EDUCATIONAL_FORM_COUNTRY_ROUTE = {
			path:
				`:discipline(${disciplinesRegex})/:educational_form` +
				`(${educationalFormRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_EDUCATIONAL_FORM_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
		};

		const COUNTRY_EDUCATIONAL_FORM_ROUTE = {
			path: `:country(${countryRegex})/:educational_form(${educationalFormRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_EDUCATIONAL_FORM_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		routes.push(
			DISCIPLINE_EDUCATIONAL_FORM_ROUTE,
			DISCIPLINE_EDUCATIONAL_FORM_COUNTRY_ROUTE,
			COUNTRY_EDUCATIONAL_FORM_ROUTE
		);

		return routes;
	}
}
